import { render } from "./SystemTopbar.vue?vue&type=template&id=e87dd0a2&scoped=true"
import script from "./SystemTopbar.vue?vue&type=script&lang=js"
export * from "./SystemTopbar.vue?vue&type=script&lang=js"

import "./SystemTopbar.vue?vue&type=style&index=0&id=e87dd0a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87dd0a2"]])

export default __exports__